import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { init } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  const packageIdSelector = getSettingValueSelector(TargetSelector.Entity, "package");
  const trialIdSelector = getSettingValueSelector(TargetSelector.Entity, "trial");
  const modeSelector = getSettingValueSelector(TargetSelector.Entity, "mode");

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      hasPackage: !!localState.package,
      isEditMode: state.isEditMode,
      packageId: packageIdSelector(state, props),
      mode: modeSelector(state, props),
      publishableKey: localState.payment?.publishableKey ?? null,
      step: localState.step,
      trialId: trialIdSelector(state, props)
    };
  };
};

const mapDispatchToProps =
  () =>
  (dispatch: any, props: RootContainerProps): ActionProps => ({
    init: () => dispatch(init(props))
  });

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
